module.exports = __webpack_public_path__ + "6bffdaba93c7a60d87a8665b0b09e3be.svg";